// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__emVO5","heading":"styles_heading__5DfP5","value":"styles_value__OgOZf"};